import script from "./JsonViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonViewer.vue?vue&type=script&setup=true&lang=js"

import "./JsonViewer.vue?vue&type=style&index=0&id=1ff0f9fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff0f9fa"]])

export default __exports__